




























import {Component, Mixins} from 'vue-property-decorator';
import SettingsTabMixin from '@/mixins/settings/SettingsTabMixin';
import AIEnum from '@/enums/AIEnum';
import CSelect from '@/components/base/select/CSelect.vue';
@Component({
    components: {CSelect},
})
export default class Import extends Mixins(SettingsTabMixin) {
    private aiEnum = AIEnum;
}
